import React, { useState } from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { useToast } from "../../controller/ToastController";
import { orderDetailOptionType } from "../../recoil/cart";
import { OptionModalType, optionModalState } from "../../recoil/optionModal";

const RecoilOptionModal: React.FC = () => {
  const showToast = useToast();
  const [modalStates, setModalStates] =
    useRecoilState<OptionModalType>(optionModalState);
  const [selectedOptions, setSelectedOptions] = useState<
    orderDetailOptionType[]
  >([]);

  const handleOptionClick = (option: orderDetailOptionType) => {
    const newSelectedOptions = [...selectedOptions];
    if (
      newSelectedOptions.findIndex(
        (item) => item.option_id === option.option_id
      ) === -1
    ) {
      if (
        selectedOptions.filter(
          (item) => item.option_type_id === option.option_type_id
        ).length < option.option_input_max! ||
        (option.option_input_max === 0 &&
          option.option_input_min === 0 &&
          selectedOptions.findIndex(
            (item) => item.option_type_id === option.option_type_id
          ) === -1)
      ) {
        newSelectedOptions.push(option);
      }
    } else {
      newSelectedOptions.splice(
        newSelectedOptions.findIndex(
          (item) => item.option_id === option.option_id
        ),
        1
      );
    }
    setSelectedOptions(newSelectedOptions);
  };

  const closeModal = () => {
    setSelectedOptions([]);
    setModalStates((prev) => ({
      ...prev,
      visibleConfirm: false,
      optionData: [],
    }));
  };

  const handleConfirm = () => {
    console.log("selectOption", selectedOptions);
    for (let i = 0; i < modalStates.modalData.option.length; i++) {
      console.log(
        "checkItem",
        modalStates.modalData.option[i][0].option_input_min,
        modalStates.modalData.option[i][0].option_type_name,
        selectedOptions.filter(
          (option) =>
            option.option_type_id ===
            modalStates.modalData.option[i][0].option_type_id
        )
      );
      if (
        (modalStates.modalData.option[i][0].option_input_max === 0 &&
          modalStates.modalData.option[i][0].option_input_min === 0 &&
          selectedOptions.filter(
            (option) =>
              option.option_type_id ===
              modalStates.modalData.option[i][0].option_type_id
          ).length === 0) ||
        (modalStates.modalData.option[i][0].option_input_min > 0 &&
          selectedOptions.filter(
            (option) =>
              option.option_type_id ===
              modalStates.modalData.option[i][0].option_type_id
          ).length < modalStates.modalData.option[i][0].option_input_min)
      ) {
        showToast("필수 옵션을 선택해주세요", "error");
        return;
      } else console.log("valid");
    }

    if (modalStates.handleConfirm) {
      modalStates.handleConfirm(modalStates.modalData.product, selectedOptions);
    }
    closeModal();
  };

  return (
    <Style>
      {modalStates.visibleConfirm && (
        <div className="modalWrap">
          <div className="modal">
            <h2 className="header">옵션 선택</h2>
            <img
              className="closeIcon"
              onClick={closeModal}
              src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
              alt="close"
            />
            <div className="optionWrap">
              {modalStates.modalData.option.map(
                (optionGroup: orderDetailOptionType[], index: number) => (
                  <div key={index} className="option">
                    <div className="optionCategory">
                      <h2 className="limitText">
                        {optionGroup[0].option_name}
                      </h2>
                      <h3 className="require">
                        {optionGroup[0].option_input_max === 0 &&
                        optionGroup[0].option_input_min === 0
                          ? "(필수 1개)"
                          : optionGroup[0].option_input_min! > 0
                          ? `(필수 ${optionGroup[0].option_input_min}개)`
                          : ""}{" "}
                        <span>
                          {optionGroup[0].option_input_min !==
                            optionGroup[0].option_input_max &&
                          optionGroup[0].option_input_max! > 0
                            ? `(최대 ${optionGroup[0].option_input_max}개)`
                            : ""}
                        </span>
                      </h3>
                    </div>
                    <div className="optionBoxWrap">
                      {optionGroup.map(
                        (option: orderDetailOptionType, optionIdx: number) => {
                          return (
                            <div
                              key={optionIdx}
                              className={`optionBox ${
                                selectedOptions.findIndex(
                                  (item) => item.option_id === option.option_id
                                ) !== -1 && "selected"
                              }`}
                              onClick={() => handleOptionClick(option)}
                            >
                              <h3 className="limitText">
                                {option.option_name}
                              </h3>
                              <p>
                                {Number(option.option_price).toLocaleString()}원
                              </p>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                )
              )}
            </div>
            <button className="successButton" onClick={handleConfirm}>
              완료
            </button>
          </div>
        </div>
      )}
    </Style>
  );
};

export default RecoilOptionModal;

const Style = styled.div`
  .modalWrap {
    width: 100vw;
    min-height: 100vh;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.4);
  }
  .modal {
    width: 60vw;
    max-height: 85vh;
    height: 85vh;
    padding: 40px 50px;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    background: #000;
    border: 1px solid #ffffff;
  }

  .header {
    text-align: center;
    font-size: 28px;
    padding-bottom: 30px;
  }
  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  /* optionWrap */
  .optionWrap {
    flex: 1;
    overflow: scroll;
  }
  .option {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    gap: 16px;

    .optionCategory {
      flex: 0 0 20%;
      h2 {
        font-size: 24px;
        font-weight: 500;
        max-width: 180px;
        white-space: pre-line;
        word-break: keep-all;
      }
      h3 {
        margin-top: 2px;
        font-size: 18px;
        line-height: 30px;
        font-weight: 500;
        color: #ff5959;
      }
      span {
        color: #6490e8;
      }
    }
  }
  .optionBoxWrap {
    display: flex;
    overflow-y: scroll;

    .optionBox {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-width: 170px;
      max-width: 170px;
      margin-right: 15px;
      padding: 21px;
      border: 1px solid #a7a7a7;
      box-shadow: 4px 4px 4px 0px #0000001a;
      border-radius: 10px;
      text-align: center;

      h3 {
        font-size: 24px;
        font-weight: 500;
        white-space: pre-line;
        word-break: keep-all;
      }
      p {
        margin-top: 19px;
        font-size: 24px;
        font-weight: 400;
        color: #a7a7a7;
      }
    }
    .optionBox.selected {
      border: 5px solid #fff;
      padding: 17px;
    }
  }

  /* successButton */
  .successButton {
    margin-top: 32px;
  }
`;
